import React, { useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import {
  images,
  audios,
  QuicktalesAddContributorsTableHeadCells,
  getComparator,
  stableSort,
} from "../../../../constants";
import ImagePreviewModal from "../../../../common/ImagePreviewModal";
import AudioModal from "../../../../common/AudioModal";
import { TableRowSectionAddContributors } from "../../components/components";
import TableHeadComponent from "../../../../common/TableHeadComponent";

export default function AddContributorsTable({
  searchedUsers,
  handleAddContributor,
}) {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("firstName");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [imagePreviewModal, setImagePreviewModal] = useState(false);
  const [audioModal, setAudioModal] = useState(false);

  console.log("users:", searchedUsers);

  const handleImagePreviewModalOpen = () => {
    setImagePreviewModal(true);
  };
  const handleImagePreviewModalClose = () => {
    setImagePreviewModal(false);
  };

  const handleAudioModalOpen = () => {
    setAudioModal(true);
  };
  const handleAudioModalClose = () => {
    setAudioModal(false);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page - 1 > 0
      ? Math.max(0, (1 + page - 1) * rowsPerPage - searchedUsers.length)
      : 0;

  const visibleRows = useMemo(
    () =>
      stableSort(searchedUsers, getComparator(order, orderBy)).slice(
        (page - 1) * rowsPerPage,
        (page - 1) * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, searchedUsers]
  );

  return (
    <Box sx={boxContainerStyles}>
      <Paper sx={paperContainerStyles}>
        <TableContainer style={{ border: "none", boxShadow: "none" }}>
          <Table aria-labelledby="tableTitle">
            <TableHeadComponent
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={visibleRows.length}
              detailsPageReports={true}
              TableHeadData={QuicktalesAddContributorsTableHeadCells}
            />
            <TableBody>
              {visibleRows.map((row, index) => {
                const labelId = `enhanced-table-checkbox-${index}`;
                const numberType = index % 2 == 0;

                return (
                  <TableRowSectionAddContributors
                    row={row}
                    numberType={numberType}
                    labelId={labelId}
                    key={index}
                    handleImagePreviewModalOpen={handleImagePreviewModalOpen}
                    handleAudioModalOpen={handleAudioModalOpen}
                    handleAddClick={() => handleAddContributor(row)}
                  />
                );
              })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
               {visibleRows.length === 0 && (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    No results found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <ImagePreviewModal
        modalOpen={imagePreviewModal}
        handleClose={handleImagePreviewModalClose}
        image={images.tableDummyImage}
      />
      <AudioModal
        modalOpen={audioModal}
        handleClose={handleAudioModalClose}
        audioFile={audios.audioSample}
      />
    </Box>
  );
}

const boxContainerStyles = {
  width: "100%",
  paddingRight: 1,
  border: "none",
  boxShadow: "none",
  marginTop: 2,
};

const paperContainerStyles = {
  width: "100%",
  mb: 2,
  border: "none",
  boxShadow: "none",
};
